module.exports = __webpack_public_path__ + "static/media/whole-foods.e62a524c.png";